module.exports = __webpack_public_path__ + "img/dl_circle.2804ce04.png";